import { useState } from 'react';
import { Link } from 'react-router-dom';
import mi from "../assets/images/mi.png";
import fi from "../assets/images/fire_insurance.png";
import ei from "../assets/images/ear_insurance.png";
import cgl from "../assets/images/CGL.png";
import pi from "../assets/images/PI.png";
import ci from "../assets/images/car_insurance.png";
import ji from "../assets/images/ji.png";
import gear from "../assets/images/gear.png";
import ship from "../assets/images/ship.png";
import evi from "../assets/images/event.png";
import wi from "../assets/images/wi.png";
import place from "../assets/images/place.png";
import ga from "../assets/images/ga.png";
import group from "../assets/images/group.png";
import wc from "../assets/images/workman.png";
import do1 from "../assets/images/do1.png";
import ghi from "../assets/images/health.png";
import emi from "../assets/images/emi.png";
import cli from "../assets/images/cyber.png";
import room from "../assets/images/room.png";
import { motion } from 'framer-motion';
import Insurance from "../assets/images/insurance.png";

/* ---------------- ICONS (same as yours) ---------------- */
// Keep all your SVG icon components here (no change)
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};
/* ---------------- INSURANCE LIST ---------------- */
const insuranceCategories = [
  { name: 'Marine Insurance', image: mi, subtitle: 'Global Trade Protected' },
  { name: 'Fire Insurance', image: fi, subtitle: 'Safeguard Against Flames' },
  { name: 'CAR Insurance', image: ci, subtitle: 'Construction Confidence' },
  { name: 'EAR Insurance', image: ei, subtitle: 'Secure Installations' },
  { name: 'Commercial General Liability', image: cgl, subtitle: 'Shield Your Business' },
  { name: 'Professional Indemnity/Errors & Ommisions', image: pi, subtitle: 'Expertise, Backed by Trust' },
  { name: 'Event Insurance', image: evi, subtitle: 'Event Risk Covered' },
  { name: 'D&O Insurance', image: do1, subtitle: 'Leadership Protected' },
  { name: 'Place of Worship Insurance', image: place, subtitle: 'Sacred Spaces Secured' },
  { name: 'Jewellery package policy', image: gear, subtitle: 'Precious Assets Protected' },
  { name: 'Group Personal Accident', image: group, subtitle: 'People First Protection' },
  { name: 'Group Health Insurance', image: ghi, subtitle: 'Workforce Health Secured' },
  { name: 'Workmen compensation', image: wc, subtitle: 'Worker Safety Coverage' },
  { name: 'Cyber Liability Insurance', image: cli, subtitle: 'Digital Risks Covered' },
];

/* ---------------- DYNAMIC DATA ---------------- */
// Each insurance has its own 3 + 3 + 3 points
const insuranceDetails = {
  "Marine Insurance": {
    coverage: [
      "ITC for domestic transfers.",
      "ICC for international exports/imports.",
    ],
    exclusions: [
      "Wear and tear of the products.",
      "Second-hand Replacement clause.",
      "Over dimensional cargo survey warranty.",
    ],
    benefits: [
      "Inland Transit Clause(ITC) with A",
      "Institute Cargo Clauses (ICC): ICC A & ICC B",
    ],
  },

  "Fire Insurance": {
    coverage: [
      "Fire, STFU, Explosion & Implosion, Riot, strike, Malicious Damage",
      "Earthquake",
      "Terrorism",
    ],
    exclusions: [
      "Deliberate, wilful, or Intentional Act.",
      "Damage to machine due to shot circuit, self heating, etc",
    ],
    benefits: [
      "No capping on Sum Insured.",
      "Option to take cover for either building or Content or Both",
    ],
  },

  "CAR Insurance": {
    coverage: [
      "Location Risk, Handling risk.",
      "Testing & commissioning risk.",
      "Act of God.",
    ],
    exclusions: [
      "War & Allied Perils.",
      "Nuclear & Allied perils.",
      "Normal wear & tear.",
    ],
    benefits: [
      "The policy is designed to meet the requirements of those involved in the construction/erection of project either as a prinicipal, contractor , sub-contractor or finance",
    ],
  },

  "EAR Insurance": {
    coverage: [
      "Location Risk, Handling risk.",
      "Testing & commissioning risk.",
      "Act of God.",
    ],
    exclusions: [
      "War & Allied Perils.",
      "Nuclear & Allied perils.",
      "Normal wear & tear.",
    ],
    benefits: [
      "The policy is designed to meet the requirements of those involved in the construction/erection of project either as a prinicipal, contractor , sub-contractor or finance",
    ],
  },

  "Commercial General Liability": {
    coverage: [
      "Premise/ Public Liability",
      "Product liability & Completed operations",
      "Various add ons few listed in benefits",
    ],
    exclusions: [
      "Errors & Omission/Professional Liability.",
      "Fraud & Dishonesty.",
      "Product Inefficacy",
    ],
    benefits: [
      "Valet Parking",
      "Terrorism liability",
      "Non-owned & Hired automobile liability.",
      "Promotional Events liability",
    ],
  },

  "Professional Indemnity/Errors & Ommisions": {
    coverage: [
      "Provides coverage for losses to third party companies arising out of error, omission or Negligence by the company or its employees.",
    ],
    exclusions: [
      "Bodily injury/Property damages",
    ],
    benefits: [
      "Coverage for acquired subsidiaries",
      "Worldwide cover",
      "Breach of Contract",
      "Loss of data or documents",
    ],
  },

  "D&O Insurance": {
    coverage: [
      "Directors & Officers policy aims at indemnifying for losses and/or defence cost that an insured suffers as a result of legal action brought for alleged wrongful acts in their capacity as directors, officers or employees of an insured company.",
    ],
    exclusions: [
      "Bodily Injury/Property Damage.",
      "Prior Litigations.",
      "Crime or Fraudulent Act",
    ],
    benefits: [
      "Misuse of corporate funds.",
      "Employment practice violation-wrongful termination, sexual harrasment etc",
    ],
  },

  "Event Insurance": {
    coverage: [
      "Cancellation/postponement of event.",
      "Material Damage cover",
      "Public liability cover",
      "Personal accident cover.",
    ],
    exclusions: [
      "Cancellation of event due to epidemic/pandemic/communicable disease would not be covered",
    ],
    benefits: [
      "Accidental Death cover for named persons.",
      "Personal injury at venue leading to hospitalisation",
    ],
  },

  "Place of Worship Insurance": {
    coverage: [
      "All places of worship recognised and are running under TRUST/NGO/Registered Entity",
    ],
    exclusions: [
      "Not for unrecognised/Inactive places of worship",
    ],
    benefits: [
      "Active structure/building aged more than 30years also can be covered subject to positive structure stability reports",
    ],
  },

  "Jewellery package policy": {
    coverage: [
      "Coverages are tailored made exclusively for Jewellery shops to cover wide range of risks.",
    ],
    exclusions: [
      "Normal merchants/retail shop owners.",
    ],
    benefits: [
      "All risk are cover including earthquake, terrorism & STFI.",
      "Transit cover",
      "Covers cash in transit, cash in safe, neon sign & plate glass.",
    ],
  },

  "Group Personal Accident": {
    coverage: [
      "Covers both employer - employee relationship policies(Permanent or contractual employees etc).",
      "Non- employer-employee groups (Associations, housing societies, trust etc)",
    ],
    exclusions: [
      "Natural death is not covered",
    ],
    benefits: [
      "Permanent total/Partial disablement.",
      "Temporary total disablement",
      "Other Add-ons available",
    ],
  },

  "Group Health Insurance": {
    coverage: [
      "Covers medical expenses for employees and family members",
    ],
    exclusions: [
      "OPD treatments & cosmetic treatments are excluded",
    ],
    benefits: [
      "Can have different SI for employee as per grades in company.",
      "Can even have co-pay options.",
    ],
  },

  "Workmen compensation": {
    coverage: [
      "Covers fatal accident for workers at work place",
    ],
    exclusions: [
      "Occupational diseases are not covered by default.",
    ],
    benefits: [
      "Accidental death.",
      "Permanent Total Disability",
      "Permanent Partial Disability",
      "Temporary Total Disability",
    ],
  },

  "Cyber Liability Insurance": {
    coverage: [
      "Provides cover for first party expense & third party liability coverage to companies when personal/confidential information is compromised and other cyber related events.",
    ],
    exclusions: [
      "Prior claims & circumstances",
      "Boodily injury/property damage",
    ],
    benefits: [
      "Security & Privacy liability.",
      "Crisis Management Costs.",
      "Multimedia liability.",
    ],
  },
};


/* ---------------- COMPONENT ---------------- */
const InsurancePage = () => {
  const [activeTab, setActiveTab] = useState('coverage');
  const [selectedInsurance, setSelectedInsurance] = useState('Marine Insurance');

  return (
    <div className="bg-gradient-to-b from-blue-50/50 to-white" style={{ marginTop: "-80px" }}>

      {/* ---------------- HERO ---------------- */}
      <section className="py-16 text-center relative min-h-[624px] flex flex-col">
        <div
          className="absolute inset-0"
          style={{
            height: "624px",
            backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,1) 10%, rgba(255,255,255,0) 60%), url(${Insurance})`,
            backgroundSize: 'cover',
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
          <motion.section
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
        <div className="max-w-6xl mx-auto px-6 relative flex flex-col flex-grow">
          <div>
            <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-4">
              Insurance, Simplified for Corporates.
            </h1>

            <p className="text-gray-600 text-lg mb-8">
              From marine to liability, clarity in every cover
            </p>
          </div>

          {/* Buttons bottom */}
          <div className="flex justify-center gap-4 mt-auto">
            <a href="#table" className="cta-primary">
              Learn More
            </a> 
{/* 
            <Link to="/contact" className="cta-secondary">
              Talk To An Advisor
            </Link> */}
          </div>
        </div>
        </motion.section>
      </section>

      {/* ---------------- INSURANCE GRID ---------------- */}
      <section className="pt-9 ">

        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

           {insuranceCategories.map((category, index) => {
  const Icon = category.icon;

  return (
    <motion.div
      key={category.name}
      onClick={() => setSelectedInsurance(category.name)}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      className={`insurance-card flex items-center gap-4 cursor-pointer p-4 rounded-lg border 
        h-[100px] w-full
        ${selectedInsurance === category.name 
  ? 'bg-gray-200 border-gray-400' 
  : 'bg-gray-200 hover:bg-gray-200'}
      `}
    >
      
      {/* Fixed Size Icon/Image Container */}
      <div className="w-30 h-30 flex items-center justify-center flex-shrink-0">
        {Icon && <Icon className="w-10 h-10" />}
        
        {category.image && (
          <img 
            src={category.image} 
            alt={category.name} 
            className="w-20 h-20 object-contain"
          />
        )}
      </div>

      {/* Title */}
      <div className="flex-1">
  <h3 className="font-semibold text-gray-900 text-sm leading-tight">
    {category.name}
  </h3>

  {/* Subtitle */}
  <p className="text-xs text-gray-500 mt-1">
    {category.subtitle}
  </p>

  {/* Divider Line */}
  {/* <div className="mt-2 h-[2px] w-10 bg-gradient-to-r from-gray-400 to-transparent rounded-full"></div> */}
</div>

    </motion.div>
  );
})}
          </div>
        </div>
        </motion.section>
      </section>

      {/* ---------------- TABS ---------------- */}
      <section className="py-12"  id="table">
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-6xl mx-auto px-6">

          {/* Tabs */}
{/* Tabs with Left & Right Lines */}
<div className="flex items-center justify-center mb-8 gap-4">

  {/* Left Line */}
  <div className="flex-1 h-[2px] bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

  {/* Tabs */}
  <div className="inline-flex bg-gray-100 rounded-lg p-1">
    {['coverage', 'exclusions', 'benefits'].map((tab) => (
      <button
        key={tab}
        onClick={() => setActiveTab(tab)}
        className={`px-4 py-2 rounded-md capitalize ${
          activeTab === tab
            ? 'bg-white shadow text-gray-900'
            : 'text-gray-500'
        }`}
      >
        {tab}
      </button>
    ))}
  </div>

  {/* Right Line */}
  <div className="flex-1 h-[2px] bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

</div>

          {/* TABLE */}
 <div className="bg-white rounded-xl shadow-[0_-10px_30px_rgba(0,0,0,0.15)] border border-gray-200 overflow-hidden">
  <table className="w-full border-collapse">

    {/* Header */}
    <thead>
      <tr className="bg-gray-50">
        <th className="text-left py-4 px-6 font-semibold text-gray-900 border-b border-gray-200">
          {selectedInsurance}
        </th>
        <th className="text-center py-4 px-6 font-semibold text-gray-900 border-b border-gray-200">
          Details
        </th>
      </tr>
    </thead>

    {/* Body */}
    <tbody>
      {(() => {
        const data = insuranceDetails[selectedInsurance][activeTab];

        // ✅ Case 1: Only ONE item → full width
        if (data.length === 1) {
          return (
            <tr className="border-b border-gray-200">
              <td
                colSpan="2"
                className="py-4 px-6 text-gray-700 text-left"
              >
                {data[0]}
              </td>
            </tr>
          );
        }

        // ✅ Case 2: Multiple items → pair them
        return data
          .reduce((rows, _, index, arr) => {
            if (index % 2 === 0) {
              rows.push([arr[index], arr[index + 1]]);
            }
            return rows;
          }, [])
          .map((pair, i) => (
            <tr
              key={i}
              className="hover:bg-gray-50 transition border-b border-gray-200"
            >
              <td className="py-4 px-6 text-gray-700 border-r border-gray-200">
                {pair[0]}
              </td>
              <td className="py-4 px-6 text-gray-700 text-center">
                {pair[1] || ""}
              </td>
            </tr>
          ));
      })()}
    </tbody>

  </table>
</div>

        </div>
        </motion.section>
      </section>

      {/* ---------------- CTA ---------------- */}
      {/* Feature Banners */}
      <section className="py-12">
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Safeguard Assets */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="feature-banner"
            >
              <img 
                src={ship}
                alt="Cargo ship"
                className="w-full h-full object-cover" style={{opacity:"0.8"}}
              />
              <div className="absolute inset-0">
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2 text-center">
                {/* <div className="flex items-center gap-4"> */}
            
                  <div>
                    <h3 className="text-2xl font-semibold text-green mb-1">
                      Safeguard Assets
                    </h3>
                    <p className="text-green/80 text-sm">
                      Project your operations with confidence.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Empower Leadership */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="feature-banner"
            >
              <img 
                src={room}
                alt="Boardroom"
                className="w-full h-full object-cover"  style={{opacity:"0.8"}}
              />
              <div className="absolute inset-0">
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2 text-center">
                  <div>
                    <h3 className="text-2xl font-semibold text-green mb-1">
                      Empower Leadership
                    </h3>
                    <p className="text-green/80 text-sm">
                      Secure your executive team
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        </motion.section>
      </section>

      {/* Testimonial */}
      <section className="py-12">
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="quote-text text-xl mb-4">
            "Our liability risks were simplified into clear coverage – no jargon, just confidence."
          </p>
          <p className="text-gray-500">— Manufacturing CEO</p>
        </div>
        </motion.section>
      </section>

      {/* CTA Buttons */}
      <section className="py-12">
        <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
<div className="flex justify-center">
  <Link
    to="/contact"
    className="bg-green-700 hover:bg-green-800 text-white px-12 py-4 rounded-full shadow-xl transition"
  >
    Book A Consultation
  </Link>
</div>    </motion.section>
      </section>

    </div>
  );
};

export default InsurancePage;